/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import "devextreme/dist/css/dx.light.css";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { getDDMMYYYFormat, getHHmmFormat, setUtcTime } from "../../../../helper/dateTimeHelper";
import {
  InputTextArea,
  InputText,
  InputDateTime,
  InputSelect,
  InputNumber,
  InputArrayData,
} from "../../../../components/input";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { ITRepairInfoService } from "../../../../services/it-repair/itRepairInfo.service";
import { MailService } from "../../../../services/mail/mail.service";
import { Button } from "../../../../modules/button";
import RadioGroup from "devextreme-react/radio-group";
import {
  department,
  unitNB,
  unitTSN,
  unitDN,
  hq1Team,
  hq2Team,
  hq3Team,
  psc1Team,
  psc2Team,
  psc3Team,
  pvhk1Team,
  pvhk2Team,
  pvhk3Team,
} from "../data";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";

import { Col, Row } from "react-bootstrap";
import { getDay, getDiffDay, getLocalDate } from "../../../../helper/dateTimeHelper";
import { repairRequestTypes } from "./repairRequestType";
import { RepairProcessContentForm, RepairProcessContentStructure } from "./repairToolForm";
import { UserSelect } from "../../../../components/input/select/UserSelect";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { Upload } from "../../upload";
import { validateRequests } from "../../../../services/util";
import { Asset } from "../../../../services/department-viags/asset.service";
import { AssetModal } from "../../modal/asset-modal";
import { useQueryClient } from "@tanstack/react-query";
import { useEmployee, useSoftwares, useUser } from "../../../../hook";
import { useUpdateRTR } from "./hooks/use-update-RTR";
import { useCreateRTR } from "./hooks/use-create-RTR";
import { SystemCode } from "../../../../constants";
import { eApproveTitleCode } from "../../../../constants/bizTitle";
import { useITTools } from "./hooks/use-it-tools";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_TOOLS_REPAIR_REQUEST_URL");

const priorities = ["Thấp", "Trung bình", "Cao"];
const fixOptions = ["Sửa chữa", "Thay thiết bị mới", "Thuê ngoài", "Nhập kho"];

export const createRepairToolsPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const today = new Date();
  const [brokenDate, setBrokenDate] = useState(today);
  const [dayOfIncreaseDate, setDayOfIncreaseDate] = useState("" as string);

  const [repairDate, setRepairDate] = useState("" as string);
  const [iTToolSelected, setITToolSelected] = useState(null as any);
  const [approver, setApprover] = useState(null as any);
  const [iTLead, setITLead] = useState(null as any);
  const [requestType, setRequestType] = useState(repairRequestTypes[0].value);
  //radio button value
  const [prioritiesSelected, setPrioritiesSelected] = useState("Thấp");
  const [fixOptionsSelected, setFixOptionsSelected] = useState("Sửa chữa");
  const [deviceLocation, setDeviceLocation] = useState(null as any);
  const [originalPrice, setOriginalPrice] = useState(null as any);
  const [residualValue, setResidualValue] = useState(null as any);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [selectedTeam, setSelectedTeam] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);
  const [team, setTeam] = useState<any>([]);
  const [numEditInYear, setNumEditInYear] = useState("" as string);
  const [isOpenAssetModal, setIsOpenAssetModal] = useState(false);
  const [assetCodeValue, setAssetCodeValue] = useState("" as string);
  const queryClient = useQueryClient();
  const { getITLeadITHeadAssignee } = useSoftwares();
  const { getApproverOptions, getEmployeesByEmail } = useEmployee();
  const { email, name } = useUser();
  const { mutate: update } = useUpdateRTR();
  const { mutate: create } = useCreateRTR();
  const { getItTool, itToolOptions } = useITTools();

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "devicetype",
        label: "Loại thiết bị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "codeTSCC",
        label: "Mã TS/CC",
        // defaultValue: {}
      },
      {
        name: "union",
        label: "Đội/Tổ",
      },
      {
        name: "deviceLocation",
        label: "Vị trí/Người sử dụng thiết bị",
      },
      {
        name: "brokenDate",
        label: "Ngày hỏng",
      },
      {
        name: "dayofIncrease",
        label: "Ngày tăng",
      },
      {
        name: "cost",
        label: "Nguyên giá",
      },
      {
        name: "residualValue",
        label: "Giá trị còn lại",
      },
      {
        name: "numEditsInYear",
        label: "Số lần sửa trong năm",
      },
      {
        name: "lastEdit",
        label: "Lần sửa gần nhất",
      },
      {
        name: "priority",
        label: "Độ ưu tiên",
      },
      {
        name: "casefix",
        label: "Phương án sửa chữa",
      },
      {
        name: "corruptedSymptoms",
        label: "Hiện tượng hỏng",
      },
      {
        name: "Cause",
        label: "Nguyên nhân:",
      },
      {
        name: "deparment",
        label: "Cơ quan/Đơn vị",
      },
      {
        name: "pickApprover",
        label: "Chọn CQ/ĐV nghiệm thu",
      },
      {
        name: "findApprover",
        label: "Chọn cán bộ CNTT",
      },
      {
        name: "findApproverReplace",
        label: "Chọn thủ trưởng CQ/ĐV thay thế",
      },
      {
        name: "type",
        label: "Đề Nghị",
      },
      {
        name: "requests",
        label: "",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
    ],

    onSubmit: async (payload) => {
      const {
        residualValue,
        cost,
        requests,
        fileRequests,
        deviceLocation,
        corruptedSymptoms,
        Cause,
        eDepartmentID,
        codeTSCC,
      } = payload;

      if (requests.length === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Phương án sửa chữa đề xuất chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!approver && id == 0) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn cán bộ thực hiện", icon: "/icons/warning.png" });
        return;
      }

      if (!iTLead && id == 0) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn thủ trưởng CQ/ĐV!", icon: "/icons/warning.png" });
        return;
      }

      const { softwareId, eApprovedByITHead } = getITLeadITHeadAssignee(SystemCode.ITR);

      let brokenTime = 0;
      // let dayOfIncreaseTime = 0;
      // let repairDateTime = 0;
      const broken = brokenDate.setHours(brokenTime, 0, 0);
      const itTool: any = getItTool(iTToolSelected);
      const approverTmp = id == 0 ? getEmployeesByEmail(approver?.userPrincipalName) : null;
      const itLeadTmp = id == 0 ? getEmployeesByEmail(iTLead?.value) : null;
      const createdJobTitle = getEmployeesByEmail(email?.toLowerCase());
      const createdHistory = [
        {
          id: "created",
          value: new Date(),
          modifiedDate: new Date(),
          user: name,
        },
        {
          id: "broken",
          value: new Date(),
          modifiedDate: new Date(),
          user: name,
        },
      ];
      const iTRepairInfos: any =
        id == 0
          ? {
              fields: {
                Title: `Sửa chữa CNTT - ${itTool.Title}`,
                eSoftwareId: softwareId,
                eToolTypeId: itTool.id,
                eDepartment: id == 0 ? selectedDepartment.value : selectedDepartment,
                eUnitRoom: id == 0 ? selectedUnit.value : selectedUnit,
                eUnion: id == 0 ? selectedTeam.value : selectedTeam,
                eDepartmentID: id == 0 ? selectedUnit.id : eDepartmentID,
                ECodeTCSSId: assetCodeValue || codeTSCC,
                ePriority: prioritiesSelected,
                eRepair: fixOptionsSelected,
                eDeviceLocation: deviceLocation,
                eBrokenDate: setUtcTime(getDay(broken)),
                eDayOfIncrease: dayOfIncreaseDate,
                eLastEdit: repairDate || "",
                eCost: cost ? cost : 0,
                eResidualValue: residualValue ? residualValue : 0,
                eNumEditsInYear: numEditInYear || "",
                eCorruptedSymptoms: corruptedSymptoms,
                eCause: Cause,
                eApprovedBy: approverTmp
                  ? `${approverTmp.eMail}|${approverTmp.Title}|${approverTmp.eBizTitle}`
                  : id == 0
                  ? `${approver.userPrincipalName}|${approver.displayName}|${approver.jobTitle}`
                  : approver,
                eRequestType: requestType,
                eRequestStatus: requestStatus.submitted,
                eContent: JSON.stringify(requests),
                eFileContent: JSON.stringify(fileRequests),
                // eApprovedByITLead: itLeadTmp ? `${itLeadTmp.eMail}|${itLeadTmp.Title}|${itLeadTmp.eBizTitle}` : id == 0 ? `${iTLead.value}|${iTLead.label}|${iTLead.biz}` : iTLead,
                eApprovedByITHead: `${eApprovedByITHead}|Đội trưởng - KCQ`,
                eAssignee: itLeadTmp
                  ? `${itLeadTmp.eMail}|${itLeadTmp.Title}|${itLeadTmp.eBizTitle}`
                  : id == 0
                  ? `${iTLead.value}|${iTLead.label}|${iTLead.biz}`
                  : iTLead,
                ePhoneNumber: createdJobTitle?.eBizTitle,
                eCreateName: createdJobTitle?.Title,
                eUpdateHistory: JSON.stringify(createdHistory),
              },
            }
          : {
              fields: {
                eToolTypeId: itTool.id,
                ECodeTCSSId: assetCodeValue || codeTSCC,
                ePriority: prioritiesSelected,
                eRepair: fixOptionsSelected,
                eDeviceLocation: deviceLocation,
                eBrokenDate: setUtcTime(getDay(broken)),
                eDayOfIncrease: dayOfIncreaseDate,
                eLastEdit: repairDate || "",
                eCost: cost ? cost : 0,
                eResidualValue: residualValue ? residualValue : 0,
                eNumEditsInYear: numEditInYear || "",
                eCorruptedSymptoms: corruptedSymptoms,
                eCause: Cause,
                eContent: JSON.stringify(requests),
                eFileContent: JSON.stringify(fileRequests),
                ePhoneNumber: createdJobTitle?.eBizTitle,
                eUpdateHistory: JSON.stringify(createdHistory),
              },
            };
      addITRepairInfo(iTRepairInfos);
    },
  });

  const sendMail = async (approver: any, itRepairToolRequest: any) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITRRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.nine + ";", itRepairToolRequest.id)
      .replace(mailRegexs.ten + ";", itRepairToolRequest.fields.eDescription ?? "")
      .replace(mailRegexs.two + ";", itRepairToolRequest.createdBy.user.displayName)
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(itRepairToolRequest.createdDateTime)} - ${getHHmmFormat(
          itRepairToolRequest.createdDateTime,
        )}`,
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  //Date broken and Rising
  const onBrokenDateChange = (date: any) => {
    const newDate = new Date(date);
    setBrokenDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(brokenDate)));
    if (days < 0) {
      setBrokenDate(newDate);
    }
  };

  // const onDayOfIncreaseDateChange = (date: any) => {
  //   const newDate = new Date(date);
  //   setDayOfIncreaseDate(newDate);
  //   const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(dayOfIncreaseDate)));
  //   if (days < 0) {
  //     setDayOfIncreaseDate(newDate);
  //   }
  //   setTimeout(() => setMinDate(newDate), 0);
  // }
  //Repair date
  // const onRepairDateChange = (date: any) => {
  //   const newDate = new Date(date);
  //   setRepairDate(newDate);
  //   const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(dayOfIncreaseDate)));
  //   if (days < 0) {
  //     setRepairDate(newDate);
  //   }
  //   setTimeout(() => setMinDate(newDate), 0);
  // }
  // End Date Broken and Rising

  const addITRepairInfo = (ITRepairInfos: any) => {
    if (id != 0) {
      update(
        { id: id, body: ITRepairInfos.fields },
        {
          onSuccess() {
            CreateNotification({
              title: "Thành công",
              body: `Chỉnh sửa yêu cầu thành công.`,
              icon: "/icons/success.png",
            });
            queryClient.invalidateQueries({ queryKey: ["repair-tools-requests"] });
            history.goBack();
          },
          onError() {
            CreateNotification({ title: "Thất bại", body: `Chỉnh sửa yêu cầu thất bại.`, icon: "/icons/error.png" });
          },
        },
      );
    } else {
      create(ITRepairInfos, {
        onSuccess(res) {
          CreateNotification({ title: "Thành công", body: `Tạo yêu cầu thành công.`, icon: "/icons/success.png" });
          if (ITRepairInfos.fields.eApprovedBy) {
            sendMail(ITRepairInfos.fields.eApprovedBy, res);
          }
          queryClient.invalidateQueries({ queryKey: ["repair-tools-requests"] });
          history.push(Routes.repairITToolDetailPage.path.replace(":id", res.id));
        },
        onError() {
          CreateNotification({ title: "Thất bại", body: `Tạo yêu cầu thất bại.`, icon: "/icons/error.png" });
        },
      });
    }
  };
  //Input type of device
  const onItToolChange = (selectedOptions: any) => {
    setITToolSelected(selectedOptions ? selectedOptions : "");
  };
  //radio change
  const onPriorityChange = (e: any) => {
    setPrioritiesSelected(e);
  };

  const onFixOptionsChange = (e: any) => {
    setFixOptionsSelected(e);
  };

  const onDepartmentChange = (selectedOptions: any) => {
    setApprover("");
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    setSelectedTeam(null);
    setTeam([]);
    if (selectedOptions && typeof selectedOptions.id === "string") {
      setSelectedUnit(selectedOptions);
      setSelectedTeam(selectedOptions);
    }
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
    setSelectedTeam(null);
  };

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const onITLeadPickerChange = (selectedOptions: any) => {
    if (selectedOptions?.target?.selectedPeople[0]) {
      const obj = {
        label: selectedOptions?.target?.selectedPeople[0]?.displayName,
        value: selectedOptions?.target?.selectedPeople[0]?.userPrincipalName,
        biz: selectedOptions?.target?.selectedPeople[0]?.jobTitle,
        default: false,
      };
      setITLead(obj);
    }
  };

  const onApproverChange = (selectedOptions: any) => {
    setITLead(selectedOptions ? selectedOptions : null);
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(selectedOptions.target.selectedPeople[0]);
  };

  const onCloseAssetModal = () => {
    setIsOpenAssetModal(false);
  };

  const onConfirm = (assets: Asset[]) => {
    const listAssetCode = assets.map((e: any) => e.codeAsset);
    const listIncreasingDate = assets.map((e: any) => getDDMMYYYFormat(e.increasingDate));
    const listRepairDate = assets.map((e: any) => getDDMMYYYFormat(e.updatedDate));
    const listNumOfUpdate = assets.map((e: any) => e.numOfUpdate);
    // if (ref.current)
    //   ref.current.value = (listAssetCode.join('; '));
    if (assets.length > 0) {
      setAssetCodeValue(listAssetCode.join("; "));
      setRepairDate(listRepairDate.join("; "));
      setNumEditInYear(listNumOfUpdate.join("; "));
      setDayOfIncreaseDate(listIncreasingDate.join("; "));
    }
  };

  //Set hook cho Cơ quan/Đơn vị
  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedUnit && selectedUnit.id) {
      if (selectedDepartment.id === 1 || selectedDepartment.id === 2 || selectedDepartment.id === 3) {
        const id = +selectedUnit?.id?.slice(-1);
        const key = selectedUnit?.id?.slice(0, -1);
        if (key === "HQ") setTeam(id === 1 ? hq1Team : id === 2 ? hq2Team : id === 3 ? hq3Team : []);
        else if (key === "PSC") setTeam(id === 1 ? psc1Team : id === 2 ? psc2Team : id === 3 ? psc3Team : []);
        else if (key === "PVHK") setTeam(id === 1 ? pvhk1Team : id === 2 ? pvhk2Team : id === 3 ? pvhk3Team : []);
        else if (key === "GA") setTeam([{ id: "GA", value: "Bộ phận hành chính tổng hợp" }]);
        else if (key === "PVHH") setTeam([{ id: "PVHH", value: "Đội phục vụ hàng hóa" }]);
        else {
          setTeam([{ id: selectedUnit.id, value: selectedUnit.value }]);
          setSelectedTeam(selectedUnit);
        }
      } else {
        setTeam([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedTeam(selectedDepartment);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit]);

  useEffect(() => {
    if (id != 0) {
      ITRepairInfoService.getITRepairInfo(id)
        .then((res) => {
          const {
            eDepartment,
            eUnitRoom,
            eUnion,
            eDepartmentID,
            ECodeTCSSId,
            eApprovedBy,
            eToolTypeId,
            eRequestType,
            eContent,
            eFileContent,
            eDeviceLocation,
            eCorruptedSymptoms,
            eCause,
            ePriority,
            eRepair,
            eCost,
            eBrokenDate,
            eDayOfIncrease,
            eLastEdit,
            eNumEditsInYear,
            eResidualValue,
            ePhoneNumber,
          } = res.fields;
          setValues({
            requests: JSON.parse(eContent),
            fileRequests: eFileContent ? JSON.parse(eFileContent) : [],
            codeTSCC: ECodeTCSSId,
            corruptedSymptoms: eCorruptedSymptoms,
            Cause: eCause,
            deviceLocation: eDeviceLocation,
            unitRoom: eUnitRoom,
            cost: eCost,
            brokenDate: eBrokenDate,
            numEditsInYear: eNumEditsInYear,
            residualValue: eResidualValue,
            lastEdit: eLastEdit,
            dayofIncrease: eDayOfIncrease,
            phoneNumber: ePhoneNumber,
            eDepartmentID: eDepartmentID,
          });
          setRequestType(eRequestType);
          setPrioritiesSelected(ePriority);
          setFixOptionsSelected(eRepair);
          setITToolSelected(eToolTypeId);
          setDeviceLocation(eDeviceLocation);
          setSelectedDepartment(eDepartment);
          setSelectedUnit(eUnitRoom);
          setSelectedTeam(eUnion);
          setOriginalPrice(eCost);
          setApprover(eApprovedBy);
          // setITLead(eApprovedByITLead);
          setResidualValue(eResidualValue);
          setDayOfIncreaseDate(eDayOfIncrease);
          setNumEditInYear(eNumEditsInYear);
          setRepairDate(eLastEdit);
        })
        .catch((error) => console.log(error));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureRepairTools.path)}>
              <Icon.ArrowLeft />
            </div>
            {id !== "0" ? "Chỉnh sửa yêu cầu sửa chữa công cụ CNTT" : "Tạo yêu cầu sửa chữa công cụ CNTT"}
          </div>
        </div>
        <Col>
          <form onSubmit={handleSubmit}>
            <Box title="I. Thông tin thiết bị:">
              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("devicetype")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={itToolOptions}
                        value={iTToolSelected}
                        onChange={onItToolChange}
                        placeholder="* Chọn thiết bị"
                      />
                    )}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("codeTSCC")}
                    renderInput={(s) => (
                      <InputText {...s} value={assetCodeValue} isDisabled={true} />
                      // <Select
                      //   options={codeTSCCTools.map((o: any) => ({ label:o.field_0 + " - " + o.Title, value: o.field_0 + " - " + o.Title, department: o.field_2, location: o?.field_3, originalPrice: o.Nguy_x00ea_ngi_x00e1_,residualValue: o.Gi_x00e1_tr_x1ecb_c_x00f2_nl_x1e  }))}
                      //   value={codeTSCCToolSelected}
                      //   onChange={onCodeTSCCToolChange}
                      //   onFocus={() => setCodeTSCCToolSelected(null)}
                      //   onInputChange={onInputTSCCChange}
                      //   placeholder={codeTSCCToolSelected ? codeTSCCToolSelected : "* Vui lòng nhập mã TSCC"} />
                      // }
                      // <InputAutoComplete
                      //   {...s}
                      //   itTools={codeTSCCTools.map((e: any) => e.value)}
                      //   onChange={handleTextAutoCompleteChange}
                      //   onSelectedChange={handleSelectedChange}
                      // />
                    )}
                  />
                  <p
                    onClick={() => setIsOpenAssetModal(true)}
                    style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                  >
                    Mở danh sách tài sản
                  </p>
                </Col>
              </Row>
              {id == 0 && (
                <Row>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("deparment")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={department.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedDepartment}
                          onChange={onDepartmentChange}
                          placeholder="* Chọn Cơ quan/ đơn vị"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("unit")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={unit.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedUnit?.value}
                          onChange={onUnitChange}
                          placeholder={"* Chọn đơn vị"}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                {id == 0 && (
                  <Col xs={id == 0 ? 12 : 0} md={id == 0 ? 6 : 0}>
                    <InputWraper
                      inputProps={getInputProps("union")}
                      renderInput={(s) => (
                        <InputSelect
                          {...s}
                          options={team.map((o: any) => ({
                            id: o.id,
                            label: o.value,
                            value: o.value,
                          }))}
                          value={selectedTeam?.value}
                          onChange={onTeamChange}
                          placeholder="* Chọn đội/tổ"
                        />
                      )}
                    />
                  </Col>
                )}
                <Col xs={12} md={id == 0 ? 6 : 12}>
                  <InputWraper
                    inputProps={getInputProps("deviceLocation")}
                    renderInput={(s) => <InputText {...s} defaultValue={deviceLocation} value={deviceLocation} />}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("brokenDate")}
                    renderInput={(s) => (
                      <>
                        <InputDateTime {...s} isDisabled={true} value={brokenDate} onChange={onBrokenDateChange} />
                      </>
                    )}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("dayofIncrease")}
                    renderInput={(s) => <InputText {...s} value={dayOfIncreaseDate} isDisabled={true} />}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("cost")}
                    renderInput={(s) => <InputNumber {...s} value={originalPrice} />}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("residualValue")}
                    renderInput={(s) => <InputNumber {...s} value={residualValue} />}
                  />
                  {getInputProps("residualValue")?.value > getInputProps("cost")?.value && (
                    <p className="text-danger px-2">❗ Giá trị còn lại phải nhỏ hơn đơn giá</p>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("numEditsInYear")}
                    renderInput={(s) => <InputText {...s} value={numEditInYear} isDisabled={true} />}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <InputWraper
                    inputProps={getInputProps("lastEdit")}
                    renderInput={(s) => <InputText {...s} value={repairDate} isDisabled={true} />}
                  />
                </Col>
              </Row>
              <Row>
                {/* Damage Phenomenon */}
                <Col xs={9} md={9}>
                  <InputWraper
                    inputProps={getInputProps("corruptedSymptoms")}
                    renderInput={(s) => <InputText {...s} />}
                    isRequired
                  />
                </Col>
                <Col xs={3} md={3}>
                  <InputWraper
                    inputProps={getInputProps("priority")}
                    renderInput={(s) => (
                      <Col className="d-flex radio-priority-content">
                        <RadioGroup
                          dataSource={priorities}
                          onValueChange={onPriorityChange}
                          value={prioritiesSelected ? prioritiesSelected : priorities[0]}
                          layout="horizontal"
                        />
                      </Col>
                    )}
                  />
                </Col>
              </Row>
            </Box>

            <Box title="II. Đội CNTT chuẩn đoán nguyên nhân:">
              <InputWraper inputProps={getInputProps("Cause")} component={InputTextArea} />
            </Box>

            <Box title="III. Phương án đề xuất" className="form__content">
              <Row className="d-flex Radio-btn-repair">
                <Col xs={12} md={12}>
                  <RadioGroup
                    id="radio-group-content"
                    dataSource={fixOptions}
                    onValueChange={onFixOptionsChange}
                    value={fixOptionsSelected ? fixOptionsSelected : fixOptions[0]}
                    layout="horizontal"
                  />
                </Col>
              </Row>
              <Row className="px-3">
                <InputWraper
                  className="from__container-input"
                  inputProps={getInputProps("requests")}
                  renderInput={(state) => (
                    <InputArrayData
                      {...state}
                      form={RepairProcessContentForm}
                      structure={RepairProcessContentStructure}
                      excelTemplate="repair-tool"
                    />
                  )}
                />
              </Row>

              <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

              {id == 0 && (
                <Row>
                  <Col sm="12" md="12">
                    <InputWraper
                      inputProps={getInputProps("findApprover")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Vui lòng chọn người cần gửi tới"
                            type={PersonType.any}
                            selectionChanged={onApproverPickerChange}
                          />
                        </div>
                      )}
                      isRequired
                    />
                  </Col>
                </Row>
              )}
              {id == 0 && (
                <Row className="py-4">
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("pickApprover")}
                      renderInput={(s) => (
                        <UserSelect
                          {...s}
                          placeholder="Vui lòng chọn CQ/ĐV Nghiệm thu"
                          options={
                            !selectedUnit
                              ? undefined
                              : getApproverOptions({
                                  eDepCodes: [selectedUnit.id],
                                  eBizTitleCodes: eApproveTitleCode.split(","),
                                })
                          }
                          value={iTLead}
                          onChange={onApproverChange}
                        />
                      )}
                      isRequired
                    />
                  </Col>
                  <Col sm="6" md="6">
                    <InputWraper
                      inputProps={getInputProps("findApproverReplace")}
                      renderInput={(s) => (
                        <div className="people_picker-custom">
                          <PeoplePicker
                            className="people-picker"
                            placeholder="Vui lòng chọn CQ/ĐV nghiệm thu"
                            type={PersonType.any}
                            selectionChanged={onITLeadPickerChange}
                          />
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              )}
            </Box>

            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="danger-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureRepairTools.path)}
              />
            </div>
          </form>
        </Col>
      </div>
      <AssetModal onConfirm={onConfirm} isOpen={isOpenAssetModal} onClose={onCloseAssetModal} />
    </div>
  );
});
